/* eslint react/no-danger: 'off' */
/* global globals, translations */
import React from 'react';
import get from 'lodash/get';

const PaymentSuccessHighlight = () => {
  const thankYou = get(translations, 'txt: Paldies, ka iegādājies {:hostname} profila izcelšanu!', '')
    // .replace('{:hostname}', `<a href="/">${window.location.hostname}</a>`);
    .replace('{:hostname}', `<a href="/">${get(globals, 'currentDomainName', 'otrapuse.lv')}</a>`);

  let activeUntil = null;
  const highlightedEndtime = get(globals, 'highlightedEndtime', null);
  if (highlightedEndtime) {
    const date = new Date(highlightedEndtime * 1000);
    const dateString = `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()}.`;
    activeUntil = get(translations, 'txt: Tavs profils ir izcelts līdz {:termins}!', '')
      .replace('{:termins}', dateString);
  }

  return (
    <div className="mtm">
      <div dangerouslySetInnerHTML={{ __html: thankYou }} />
      <div dangerouslySetInnerHTML={{ __html: activeUntil }} />
      <div className="mtm">
        <a href="/">{get(translations, 'txt: Sākums', '')}</a>
      </div>
    </div>
  );
};

export default PaymentSuccessHighlight;
